import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ForgotPassword } from "./ForgotPassword";
import { SetPassword } from "./SetPassword";
import { OfflineBanner } from "./OfflineBanner";
// Shared sign-in component lives in Edge.Client/src. Same source serves the
// inspire-login CF Pages bundle here AND Edge.Client's /login route — one
// implementation, two outputs. The cross-project import is wired via the
// `@` alias in vite.config.ts. Cloud's CF Pages bundle gets the lightweight
// build (just the auth pages); Edge.Client cloud build EXCLUDES login.tsx
// via the vite-plugin-pages exclude (see Edge.Client/vite.config.ts).
import { SignIn } from "@/components/auth/SignIn";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

const params = new URLSearchParams(window.location.search);

// ?redirect=/app/... is only honoured if it's a same-origin path.
// Rejects protocol-absolute URLs and protocol-relative "//host/path"
// so a phished link can't funnel the user to an attacker's site after
// sign-in.
const rawRedirect = params.get("redirect") || "/";
const redirect =
    rawRedirect.startsWith("/") && !rawRedirect.startsWith("//") ? rawRedirect : "/";

// Single-page router: each path renders a different component, all
// served by the same index.html (CF Pages `_redirects` handles the
// SPA fallback). Trailing slash tolerated; everything else falls
// through to the default sign-in page.
const path = window.location.pathname.replace(/\/+$/, "") || "/";

createRoot(root).render(
    <StrictMode>
        <OfflineBanner />
        {routeFor(path, redirect)}
    </StrictMode>,
);

function routeFor(path: string, redirectTo: string) {
    switch (path) {
        case "/forgot-password":
            return <ForgotPassword />;
        case "/reset-password":
            return <SetPassword mode="reset" redirectTo={redirectTo} />;
        case "/accept-invite":
            return <SetPassword mode="invite" redirectTo={redirectTo} />;
        default:
            return <SignIn redirectTo={redirectTo} />;
    }
}
